import { render, staticRenderFns } from "./TeamAnalysis.vue?vue&type=template&id=791564b2&"
import script from "./TeamAnalysis.vue?vue&type=script&lang=ts&"
export * from "./TeamAnalysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports